import { getInitCookie } from '../../browser/cookie';
import { globalObject, isWorkerEnvironment } from '../../tools/globalObject';
import { tryJsonParse } from '../../tools/utils/objectUtils';
const cookieNamePrefix = 'datadog-synthetics-';
export const SYNTHETICS_TEST_ID_COOKIE_NAME = `${cookieNamePrefix}public-id`;
export const SYNTHETICS_RESULT_ID_COOKIE_NAME = `${cookieNamePrefix}result-id`;
export const SYNTHETICS_INJECTS_RUM_COOKIE_NAME = `${cookieNamePrefix}injects-rum`;
export const SYNTHETICS_CONTEXT_COOKIE_NAME = `${cookieNamePrefix}rum-context`;
export function willSyntheticsInjectRum() {
    if (isWorkerEnvironment) {
        // We don't expect to run synthetics tests in a worker environment
        return false;
    }
    return Boolean(globalObject._DATADOG_SYNTHETICS_INJECTS_RUM || getInitCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
export function getSyntheticsContext() {
    const raw = getRawSyntheticsContext();
    return isValidSyntheticsContext(raw) ? raw : undefined;
}
export function isSyntheticsTest() {
    return Boolean(getSyntheticsContext());
}
function getRawSyntheticsContext() {
    const rawGlobal = globalObject._DATADOG_SYNTHETICS_RUM_CONTEXT;
    if (rawGlobal) {
        return rawGlobal;
    }
    const rawCookie = getInitCookie(SYNTHETICS_CONTEXT_COOKIE_NAME);
    if (rawCookie) {
        return tryJsonParse(decodeURIComponent(rawCookie));
    }
    return {
        test_id: window._DATADOG_SYNTHETICS_PUBLIC_ID || getInitCookie(SYNTHETICS_TEST_ID_COOKIE_NAME),
        result_id: window._DATADOG_SYNTHETICS_RESULT_ID || getInitCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME),
    };
}
function isValidSyntheticsContext(value) {
    return (typeof value === 'object' &&
        value !== null &&
        typeof value.test_id === 'string' &&
        typeof value.result_id === 'string');
}
//# sourceMappingURL=syntheticsWorkerValues.js.map